import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import clsx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import variables from '../../Sys/variable.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 0,
  },
  title: {
    color: 'var(--dm-text-strong, #263548)',
    fontSize: '0.9375rem',
    fontWeight: 700,
    lineHeight: 1.35,
    marginBottom: theme.spacing(1.5),
  },
  legacyTitle: {
    color: variables.labelcolor,
  },
}));

const ChartContainer = ({
  title,
  children,
  childStyleOveride,
  styleOveride,
  className,
  titleClassName,
}) => {
  const classes = useStyles();
  const hasCustomPanel = Boolean(className);

  return (
    <Grid
      className={clsx(classes.root, className)}
      style={styleOveride || (hasCustomPanel ? undefined : { marginTop: 32 })}
    >
      <Grid container justifyContent={'space-between'}>
        {title &&
          <Grid item xs={12}>
            <Typography
              component="h2"
              className={clsx(
                hasCustomPanel || titleClassName ? classes.title : classes.legacyTitle,
                titleClassName,
              )}
              style={!hasCustomPanel && !titleClassName ? { fontSize: '1.5rem', fontWeight: 500 } : undefined}
            >
              {title}
            </Typography>
          </Grid>
        }
      </Grid>
      <Grid style={childStyleOveride ? childStyleOveride : null}>{children}</Grid>
    </Grid>
  );
};

ChartContainer.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  childStyleOveride: PropTypes.object,
  styleOveride: PropTypes.object,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
};

export default ChartContainer;
